import React, { forwardRef } from 'react';
import {
	Fullscreen,
	FullscreenBody,
} from '@atlassian/jira-minimizable-modal/src/ui/modal-container/fullscreen/index.tsx';
import { useTriggerIssueCreateModal } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/main.tsx';
import { GIC_VARIANTS } from '../../../../common/ui/footer/constants.tsx';
import Footer from '../../../../common/ui/footer/index.tsx';
import { useMinimizableModalWrapperProps } from '../../../../controllers/minimizable-modal-wrapper-props/main.tsx';
import type { MinimizableFullscreenProps } from './types.tsx';

export const MinimizableFullscreen = forwardRef<HTMLElement, MinimizableFullscreenProps>(
	({ children, ...rest }: MinimizableFullscreenProps, ref) => {
		const {
			onModalCloseWithConfirm,
			onSubmit,
			isSubmitting,
			isOperationInProgress,
			canCreateAnotherIssue,
			onCreateAnotherChange,
			getShouldDisableSubmit,
			createdIssues,
			displayCreateAnotherIssueToggle,
			dismissModalEntryPointWrapper,
		} = useMinimizableModalWrapperProps();

		const [{ containerStyle }] = useTriggerIssueCreateModal();
		return (
			// @ts-expect-error - TS2746 - This JSX tag's 'children' prop expects a single child of type 'HTMLCollection', but multiple children were provided.
			<Fullscreen ref={ref} {...rest}>
				<FullscreenBody containerStyle={containerStyle}>{children}</FullscreenBody>
				<Footer
					onClose={onModalCloseWithConfirm('cancel')}
					onSubmit={onSubmit}
					isSubmitting={isSubmitting}
					isOperationInProgress={isOperationInProgress}
					canCreateAnotherIssue={canCreateAnotherIssue}
					onCreateAnotherChange={onCreateAnotherChange}
					shouldDisableSubmit={getShouldDisableSubmit()}
					createdIssues={createdIssues}
					variant={GIC_VARIANTS.MINI}
					displayCreateAnotherIssueToggle={displayCreateAnotherIssueToggle}
					containerStyle={containerStyle}
					showCancelButton
					dismissModalEntryPointWrapper={dismissModalEntryPointWrapper}
				/>
			</Fullscreen>
		);
	},
);
